export default {
    filters: {
        title: "Filter",
        removeFilter: "Entfernen Sie den Filter",
        filterIntensity: "Filterintensität",
        duotone: {
            title: "Duoton",
            desert: "Wüste",
            peach: "Pfirsich",
            clash: "Konflikt",
            plum: "Pflaume",
            breezy: "Luftig",
            deepBlue: "Tiefblau",
            frog: "Frosch",
            sunset: "Sonnenuntergang",
        },
        blackAndWhite: {
            title: "B und W",
            ad: "1920 N. Chr",
            greyed: "Ergraut",
            dusty: "Staubig",
            litho: "Lithografie",
            sepia: "Sepia",
            weathered: "Verwittert",
            hardStuff: "Harter Stoff",
        },
        vintage: {
            title: "Vintage",
            polaroid: "Polaroid",
            sunny: "Sonnige 70er",
            oldTimer: "Oldtimer",
            inferno: "Inferno",
            snappy: "Schnappig",
        },
        smooth: {
            title: "Glatt",
            chestnut: "Kastanie",
            softy: "Weichling",
            pebble: "Kieselstein",
            moss: "Moos",
            lemon: "Zitrone",
            greenGap: "Grüne Lücke",
        },
        cold: {
            title: "Kalt",
            colla: "Kleber",
            solanus: "Solanus",
            kalmen: "Kalmen",
            jorah: "Joran",
            levante: "Levante",
            zephyr: "Zephir",
        },
        warm: {
            title: "Warm",
            golden: "Golden",
            lowFire: "Schwaches Feuer",
            sunrise: "Sonnenaufgang",
            flatBack: "Flacher Rücken",
            pumpkin: "Kürbis",
        },
    },
};
